module.exports = __webpack_public_path__ + "static/media/ipl_auction.786b7b16.png";